import { SectionName } from 'modules/home/constants';

import { baseApi } from 'utils/apiUtil';
import { http } from 'utils/httpUtil';

const employerUrl = `${baseApi}/v1/employers`;
const benguideServiceUrl = `${baseApi}/v2/benefit-guides`;

export const getPlanYearData = async (
  employerId: string,
  planYearId: string
) => {
  return http.get(`${employerUrl}/${employerId}/plan-years/${planYearId}`);
};

export const getRichMedia = async (
  benguideId: string,
  sectionName: SectionName
) => {
  return http.get(
    `${benguideServiceUrl}/${benguideId}/rich-media?section-name=${sectionName}`
  );
};

export const getSectionImage = async (
  benguideId: string,
  sectionName: SectionName,
  revision: number
) => {
  return http.get(
    `${benguideServiceUrl}/${benguideId}/images?section-name=${sectionName}&revision=${revision}`
  );
};

export const getSectionImageUrl = (
  benguideId: string,
  sectionName: SectionName,
  revision: number
) => {
  return `${benguideServiceUrl}/${benguideId}/images?section-name=${sectionName}&revision=${revision}`;
};

export const getDefaultRichMedia = async (
  benguideId: string,
  sectionName: SectionName
) => {
  return http.get(
    `${benguideServiceUrl}/${benguideId}/rich-media?section-name=${sectionName}&default-value=${true}`
  );
};

export const getCustomNavigationTitles = async (benguideMasterId: string) => {
  return http.get(
    `${benguideServiceUrl}/${benguideMasterId}/custom-navigation-titles`
  );
};

export const updateCustomNavigationTitles = async (
  benguideMasterId: string,
  data: any
) => {
  return http.put(
    `${benguideServiceUrl}/${benguideMasterId}/custom-navigation-titles`,
    data
  );
};

export const saveDisclosureTemplate = (
  organizationId: string,
  benefitGuideId: string,
  templateContent: string
) => {
  return http.put(
    `${baseApi}/v2/organizations/${organizationId}/${benefitGuideId}/configurations/disclosure-template`,
    {
      templateContent: templateContent,
    }
  );
};

export const getDisclosureTemplate = (organizationId: string) => {
  return http.get(
    `${baseApi}/v2/organizations/${organizationId}/configurations/disclosure-template`
  );
};

export const saveFooterTemplate = (
  organizationId: string,
  benefitGuideId: string,
  templateContent: string
) => {
  return http.put(
    `${baseApi}/v2/organizations/${organizationId}/${benefitGuideId}/configurations/footer-template`,
    {
      templateContent: templateContent,
    }
  );
};

export const getFooterTemplate = (organizationId: string) => {
  return http.get(
    `${baseApi}/v2/organizations/${organizationId}/configurations/footer-template`
  );
};
